/**
 * Couleur de projet dérivée de son id (spec §2.4) — aucune colonne en base. Six séries de
 * tokens `--serie-1..6` (`client/src/index.css`), en chaînes littérales : Tailwind v4 ne génère
 * jamais une classe construite par interpolation (`` `text-serie-${n}` ``, plan § pièges).
 */

export const PROJECT_SERIES = [
  { text: 'text-serie-1', border: 'border-serie-1' },
  { text: 'text-serie-2', border: 'border-serie-2' },
  { text: 'text-serie-3', border: 'border-serie-3' },
  { text: 'text-serie-4', border: 'border-serie-4' },
  { text: 'text-serie-5', border: 'border-serie-5' },
  { text: 'text-serie-6', border: 'border-serie-6' },
];

/** Index déterministe 0-5, dérivé de l'id (somme des codes de caractères modulo 6). */
export function projectColorIndex(id) {
  let sum = 0;
  for (let i = 0; i < id.length; i += 1) sum += id.charCodeAt(i);
  return sum % PROJECT_SERIES.length;
}

/** Classes de la série d'un projet, prêtes à composer dans un `className`. */
export function projectColor(id) {
  return PROJECT_SERIES[projectColorIndex(id)];
}
